import { render, staticRenderFns } from "./NotesSetting.vue?vue&type=template&id=4cc5a490&"
import script from "./NotesSetting.vue?vue&type=script&lang=js&"
export * from "./NotesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc5a490')) {
      api.createRecord('4cc5a490', component.options)
    } else {
      api.reload('4cc5a490', component.options)
    }
    module.hot.accept("./NotesSetting.vue?vue&type=template&id=4cc5a490&", function () {
      api.rerender('4cc5a490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/NotesSetting.vue"
export default component.exports